export default __webpack_public_path__ + "assets/dateRange.ced4a30c.svg";